import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MinMaxDateFilter from './min-max-date-filter-template'

export default class VideoGame extends Component {
  static propTypes = {
    feed: PropTypes.object
  }

  render() {
    return (
      <div>
        <MinMaxDateFilter feed={this.props.feed} />
      </div>
    )
  }
}
